export const API_HOST = `${process.env.REACT_APP_API_HOST}`;
export const DEFAULT_ACCESS_TOKEN = `${process.env.REACT_APP_DEFAULT_ACCESS_TOKEN}`;
